import { ucApi, userApi, assetApi, $assets, subApi, vipApi } from '@/config/api';
import { removeCookie } from '@/utils/cookie';
import { stayRoute } from '@/config/setup';
import { getOriginPath } from '@/lang/i18n';
import verifyType from '@/config/verify-type';
import { delay } from '@/utils/tools';
import { T } from 'chart.js/dist/chunks/helpers.core';
import { useLayoutStore } from '@/store/layout';
import defaultAvatar from '@/assets/img/user/default-avatar.png';
import { clearDeviceToken } from '@/utils/deviceToken';
interface Userinfo {
  userId: string;
  registerType: number;
  mobile: string;
  nationalCode: string;
  email: string;
  bindGA: boolean;
  bindTradePwd: boolean;
  bindPassword: boolean;
  userType: number;
  verifyStatus: number;
  kycLevel: number;
  kycVerifyStatus: number;
  displayLevel: string;
  accounts: [];
  defaultAccountId: string;
  registerDate: string;
  openOption: boolean;
  openFuture: boolean;
  openMargin: boolean;
  learnWithdraw: boolean;
  learnDeposit: boolean;
  favorites: [];
  source: string;
  isAgent: number;
  customLabelList: [];
  levelNames: [];
  leader: number;
  isHobbit: number;
  antiPhishingCode: string;
  isComplianceVerify: boolean;
  lastLoginDate: string;
  avatar: string;
  masterUserId: string;
  agentStatus: number;
  inInviteBlack: boolean;
  bindGoogle:boolean;
  bindApple:boolean;
  bindGoogleEmail:string;
  bindAppleEmail:string;
  thirdPartyAuthType:string;
  hasAgentExclusiveActive: number;
  isApikeyWhite: boolean;
  apikeyWhiteAllowTrade: boolean;
  isBD: boolean;
  specialKrAgent: boolean;
  countryCode:string;
  isKyc:boolean;
  inputInviteCode: string;
  nickname: string;
  profilePictureUrl: string;
  isShadowBD: string;
  gender: number;
  birthday: any;
  introduction: string;
  locationCode: string;
  apikeyWhiteCheckKyc: boolean;
}
interface LoginUser {
  userId: string;
  registerType: number;
  mobile: string;
  nationalCode: string;
  email: string;
  bindGA: boolean;
  bindTradePwd: boolean;
  bindPassword: boolean;
  userType: number;
  verifyStatus: number;
  kycLevel: number;
  kycVerifyStatus: number;
  displayLevel: string;
  accounts: [];
  defaultAccountId: string;
  registerDate: string;
  source: string;
  inviteUserId: string;
  secondLevelInviteUserId: string;
  isAgent: number;
  customLabelList: [];
  antiPhishingCode: string;
  isComplianceVerify: false;
  lastLoginDate: string;
  lastLoginIp: string;
  platfrom: string;
}

interface KycInfo {
  userKycinfo: any,
  needVedioVerify: any,
  currentLevelInfo: any,
  // withdrawDailyLimit: string,
  // withdrawLimitToken: string
}

interface VerifyInfo {
  current_level: number,
  displayLevel: string,
  verifyStatus: number,
  refusedReason: string,
  cardNo: string,
  nationality: string,
  firstName: string,
  secondName: string,
  middleName?: string,
  refusedReasonId:number,
  cardType: string,
  cardTypeCode: number
}
interface WhiteList {
  withdrawWhiteList: Array<T>,
  depositWhiteList:  Array<T>,
}

const clearUserLocalData = () => {
  // 由于cookie设置了 httponly secure 属性，无法通过js操作cookie，暂时保留
  removeCookie('account_id');
  removeCookie('au_token');
  removeCookie('activity_id');
  clearDeviceToken();
  window.sessionStorage.removeItem('userInfo');
  window.sessionStorage.removeItem('last_show_time');
};

export const useUserStore = defineStore('userStore', {
  state: () => ({
    whiteList: {

    }as WhiteList,
    withdrawWhiteStatus: false,
    userinfo: {} as Userinfo,
    baseUserInfo: {} as LoginUser,
    countriesList: [] as any,
    // kyc信息
    kycInfo: {} as KycInfo,
    // kyc验证信息
    verifyInfo: {} as VerifyInfo,
    // 子账户
    subAccount: <any>null,
    // 当前子账户资产
    subAssets: [] as [],
    // 子账户map
    subAccountMap: <any>{},
    // 子账户资产轮循控制器
    timeSubAsset: <any>null,
    // 登录状态定时器
    loginStateTimer: <any>null,
    // 邀请码
    inviteCode: <string>'',
    // 新版-子账户列表
    subAccountList: [] as any,
    // api权限列表
    apiKeyAuthList: [] as any,
    levelInfo: {} as any,
    // 各数据的加载状态
    loading: {
      userInfo: false
    },
    showKoreaKyc: true,
    verifyType: <Array<string>>[]
  }),
  getters: {
    isLogin(state): boolean {
      return !!state.userinfo?.userId;
    },
    isKyc(state) {
      return state.userinfo.isKyc;
    },
    isKoreaKyc(state) {
      // false 展示
      if (!state.userinfo.userId) {
        return true;
      }
      if (state.userinfo.countryCode !== 'KR') {
        return true;
      }
      if (state.userinfo.countryCode == 'KR' && !state.userinfo.isKyc) {
        return false;
      }
      return true;
    },
    // 获取kyc信息
    getKycInfo(state) {
      const { kycInfo, verifyInfo } = state;

      if (!Object.keys(kycInfo).length) {
        return {};
      }

      if (!Object.keys(verifyInfo).length) {
        return kycInfo;
      }
      /**
       * needVedioVerify 三级kyc是否打开
       * userKycinfo: kyc各级别信息
       * currentLevelInfo 当前级别信息
       */
      const obj:any = {
        ...kycInfo,
        currentLevelInfo: kycInfo.userKycinfo.find(
          (data: any) => data.displayLevel == verifyInfo.displayLevel
        ) || {}
      };

      return obj;
    },
    // 是否为子账户
    isSubAccount(state) {
      return state.userinfo.userId && state.userinfo?.masterUserId !== '0';
    },
    // h5用户信息
    userAccount(state) {
      if (!!state.userinfo.userId) {
        if (state.userinfo.registerType === 2) {
          return state.userinfo.email.replace(/\*{4,}/g, '***');
        } else {
          return state.userinfo.mobile;
        }
      } else {
        return '';
      }
    },
    countriesListMapCountry(state) {
      const obj: any = {};
      state.countriesList.forEach((item: any) => {
        obj[item.nationalCode] = item;
      });
      return obj;
    },
    isPersianUser(state) {
      return state.userinfo?.userId && ['IR', 'BU', 'TJ', 'AF', 'AZ'].includes(state.userinfo?.countryCode);
    }
  },
  actions: {
    getUserinfo() {
      this.loading.userInfo = true;
      return new Promise(async resolve => {
        const data: any = await ucApi.userinfo();
        this.loading.userInfo = false;

        if (data.code === 200) {
          resolve(true);
          this.userinfo = data.data || {};

          try {
            data.data?.userId && sessionStorage.setItem('UID', data.data?.userId);
          } catch (e) {}
          
          if (!this.userinfo.avatar) {
            this.userinfo.avatar = defaultAvatar;
            // this.userinfo.avatar = 'https://s3.ap-northeast-1.amazonaws.com/s3.toobit.com/images/account_icon/1533208313-1.png';
          }
          // 请求子账户
          this.getSubAccountList();
          if (!this.loginStateTimer) {
            this.loginStateLoop();
          }
        }

        resolve(false);
      });
    },
    loginStateLoop() {
      this.loginStateTimer = setTimeout(async() => {
        if (this.isLogin) {
          const res: any = await ucApi.isLogin();

          if ((res.success && res.data.userId) || res.code === 500) {
            this.loginStateLoop();
          } else {
            this.logOut();
          }
        } else {
          clearTimeout(this.loginStateTimer);
        }
      }, 5000);
    },
    logOutH5() {
      clearUserLocalData();
      const layoutStore = useLayoutStore();

      ucApi.logout({}).then((res: any) => {
        if (res.success) {
          if (layoutStore.routeMeta?.isStay) {
            window.location.reload();
          } else {
            window.location.href = '/h5/home';
          }
        }
      });
    },
    logOut() {
      clearUserLocalData();
      const layoutStore = useLayoutStore();

      const { search, pathname } = window.location;

      // 有时间再优化这里
      const isStay = stayRoute && Array.isArray(stayRoute)
        ? stayRoute.some((item: any) => {
          const path = getOriginPath(pathname);
          if (item instanceof RegExp) {
            return item.test(path);
          } else {
            return item === path;
          }
        })
        : false;

      setTimeout(() => {
        // 退出登录接口
        // 留在当前页面
        ucApi.logout({}).then((res: any) => {
          if (res.success) {
            if (isStay || layoutStore.routeMeta?.isStay) {
              window.location.reload();
            } else {
              const path = getOriginPath(pathname);
              if (path == '/user/resetpassword') {
                window.location.href = '/login';
                return;
              }
              window.location.href = `/login?backurl=${pathname.replace(/^\/\w{2}-\w{2}\//, '/')}${search}`;
            }
          }
        });
      }, 10);
    },
    getCountries(params?:any) {
      // todo 不同场景需要传不一样的type
      // if (this.countriesList.length) {
      //   return;
      // }
      // 国家区号列表
      ucApi.getCountries(params).then((data: any) => {
        this.countriesList = [];
        if (data.code === 200) {
          data.data
            // .filter((item:any) => item.nationalCode === "86")
            .forEach((item: never) => {
              this.countriesList.push(item);
            });
        }
      });
    },
    getWhiteList() {
      userApi.whiteList().then((data: any) => {
        this.whiteList = [];
        if (data.code === 200) {
          this.whiteList = data.data;
        }
      });
    },
    // 获取提币地址白名单状态
    getWithdrawWhiteStatus() {
      $assets.withdrawWhiteStatus().then((res: any) => {
        if (res.code === 200) {
          this.withdrawWhiteStatus = res.data?.status;
        }
      });
    },
    /**
     * 获取kyc信息
     */
    requestKycInfo() {
      userApi.getUserKycInfo()
        .then((data: any) => {
          if (data.success) {
            const needVedioVerify: any = data.data.find(
              (data: any) => data.displayLevel == '3'
            );

            this.kycInfo = {
              needVedioVerify: needVedioVerify
                ? needVedioVerify.allowVerify
                : false, // 三级kyc是否打开
              userKycinfo: data.data,
              currentLevelInfo: 0
            };
          }
        });
    },
    /**
     * 验证信息
     */
    sendVerifyInfo() {
      userApi.getVerifyInfo()
        .then((data: any) => {
          if (data.success) {
            this.verifyInfo = data.data;
          }
        });
    },
    /**
     * 请求子账户列表
     *
     * @param isTransfer 是否是划转，在划转时请求子账户如果已有子账户那么不用重复请求
     * @returns
     */
    async sendtSubAccount(isTransfer = false) {
      if (isTransfer && this.subAccount && this.subAccount.length) {
        return;
      }

      const res: any = await assetApi.sendSubAccount();

      if (res.success) {
        this.subAccount = res.data;

        // 子账户map
        // res.data.forEach((item: any) => {
        //   if (!this.subAccountMap[item.accountId]) {
        //     this.subAccountMap[item.accountId] = item;
        //   }
        // });
      }
    },
    async getInviteCode() {
      const res: any = await userApi.getInviteCode({});
      if (res.success) {
        this.inviteCode = res.data.inviteCode;
      }
    },
    async getSubAccountList() {
      const res:any = await subApi.getSubList({});
      if (res.success) {
        this.subAccountList = res.data;
      }
    },
    async getApiKeyAuthList() {
      const res:any = await subApi.getApiKeyAuthList({});
      if (res.success) {
        this.apiKeyAuthList = res.data;
      }
    },
    // 获取用户等级信息
    async getLevelInfo() {
      const res:any = await vipApi.levelConfigs({ checkProLevel: true });
      if (res.success) {
        this.levelInfo = res.data;
      }
    },
    // 获取验证类型
    async getVerifyType(type:string, onAddressBook = false) {
      if (!type || !verifyType[type]) {
        return;
      }
      let res:any = await userApi.getVerifyType({
        scene: verifyType[type],
        args: onAddressBook ? 'onAddressBook' : ''
      });
      if (res.success) {
        this.verifyType = res.data || [];
        return res.data;
      } else {
        await delay(1000);
        res = await userApi.getVerifyType({
          scene: verifyType[type],
          args: onAddressBook ? 'onAddressBook' : ''
        });
        if (res.success) {
          this.verifyType = res.data || [];
          return res.data;
        } else {
          return [];
        }
      }
    },
    async GetFrozenList() {
      return await ucApi.getFrozenList({});
    }
  }
});
